
const config = {
    ENVIROMENT: process.env.REACT_APP_ENVIROMENT,
};
export default config;